import {createSlice, PayloadAction} from '@reduxjs/toolkit';

interface IMyStore {
  input_guid?: Array<IFiltersKeyValuePairs>;
  search?: string;
  sorting?: string;
  status_list: {
    pending: boolean;
    rejected: boolean;
    expired: boolean;
    promoted: boolean;
  };
}
interface IFiltersKeyValuePairs {
  guid: string;
  title: string;
}

const initialState: IMyStore = {
  input_guid: [],
  sorting: '',
  status_list: {
    pending: false,
    rejected: false,
    expired: false,
    promoted: false,
  },
};

export const myStoreSlice = createSlice({
  name: 'myStore',
  initialState,
  reducers: {
    addFilters: (state, action: PayloadAction<IMyStore>) => {
      Object.keys(action.payload).map(
        //@ts-ignore
        item => (state[item] = action.payload[item]),
      );
    },
    clearFilter: state => {
      state.status_list = {
        pending: false,
        rejected: false,
        expired: false,
        promoted: false,
      };
    },
  },
});

export const {addFilters, clearFilter} = myStoreSlice.actions;

export default myStoreSlice.reducer;
